import { STORAGE_NAME_PREFIX, getStorageName } from './storage'

export const QUESTION_FILE_UPLOAD_STORE_NAME = `questionsFileUploadData`

export async function getDb(playbookId) {
  return new Promise((resolve, reject) => {
    const dbName = getStorageName(playbookId)
    const request = indexedDB.open(dbName)

    request.onupgradeneeded = function () {
      const db = this.result
      // Create an object store with "id" as the key
      if (!db.objectStoreNames.contains(QUESTION_FILE_UPLOAD_STORE_NAME)) {
        db.createObjectStore(QUESTION_FILE_UPLOAD_STORE_NAME, { keyPath: 'id', autoIncrement: true }) // "id" is the primary key
      }
    }

    request.onsuccess = function () {
      resolve(this.result)
    }

    request.onerror = function () {
      reject(this.error)
    }
  })
}

export async function deleteDb(playbookId) {
  const dbName = getStorageName(playbookId)
  await deleteDbByName(dbName)
}

export async function deleteDbByName(dbName) {
  return new Promise((resolve, reject) => {
    const deleteRequest = indexedDB.deleteDatabase(dbName)

    deleteRequest.onsuccess = function () {
      resolve()
    }

    deleteRequest.onerror = function () {
      reject(this.error)
    }

    deleteRequest.onblocked = function () {
      reject()
    }
  })
}
